<template>
  <el-container class="view_content">
    <el-aside width="auto">
      <common-aside></common-aside>
    </el-aside>

    <el-container>
      <el-header>
        <common-header></common-header>
      </el-header>
      <!--      tab-->
      <div class="template-tabs">
        <el-tabs v-model="activeIndex" type="border-card" closable @tab-click="tabClick" @tab-remove="tabRemove">
          <el-tab-pane v-for="(item) in options" :key="item.name" :label="item.name" :name="item.route">
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CommonHeader from '../components/CommonHeader'
import CommonAside from '../components/CommonAside'

export default {
  name: 'Main',
  components: {
    CommonHeader,
    CommonAside
  },
  computed: {
    options() {
      return this.$store.getters.getTabOptions
    },
    //动态设置及获取当前激活的tab页
    activeIndex: {
      get() {
        return this.$store.getters.getActiveIndexs
      },
      set(val) {
        this.$store.commit('set_active_index', val)
      }
    }
  },
  watch: {
    '$route'(to) {
      const role = this.$store.state.role
      const showName = this.$store.getters.getShowName
      let flag = false//判断是否页面中是否已经存在该路由下的tab页
      //options记录当前页面中已存在的tab页getOptions
      for (const option of this.options) {
        //用名称匹配，如果存在即将对应的tab页设置为active显示桌面前端
        if (option.name === showName) {
          flag = true
          this.$store.commit('set_active_index', to.path)
          break
        }
      }
      //如果不存在，则新增tab页，再将新增的tab页设置为active显示在桌面前端
      // if(role!='nopass'){}
      if (role === 'pass') {
        if (!flag) {
          this.$store.commit('add_tabs', { route: to.path, name: showName })
          this.$store.commit('set_active_index', to.path)
        }
      }
    }
  },
  methods: {
    // tab切换时，动态的切换路由
    tabClick(tab) {
      const path = this.activeIndex
      this.$router.push({ path: path })
      this.$store.commit('set_role', 'nopass')
    },
    tabRemove(targetName) {
      this.$store.commit('set_role', 'nopass')
      // let tabs = this.editableTabs;
      this.$store.commit('delete_tabs', targetName)
      // 如果激活的关闭的tab就是激活的tab
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.options && this.options.length >= 1) {
          this.$store.commit('set_active_index', this.options[this.options.length - 1].route)
          this.$router.push({ path: this.activeIndex })
        } else {
          this.$router.push({ path: '/AppMain' })
        }
      }
    }
  }
}
</script>

<style>
  .view_content {
    height: 100vh;
  }

  .el-header {
    background-color: #2B2F3A;
    padding-left: 10px;
    height: 50px !important;
  }

  .el-aside {
    border: 0;
  }

  .el-main {
    height: 90vh;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 230px;
    min-height: 400px;
  }
</style>
